import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, Share2, Globe } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer
      className="border-t mt-20"
      style={{
        backgroundColor: 'var(--mi-fg)',
        borderColor: 'var(--mi-fg)',
        color: '#FAFAF8',
        paddingTop: '40px',
        paddingBottom: '40px',
      }}
    >
      <div className="mi-container pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">

          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 font-display text-xl tracking-tight mb-4">
              <span className="text-2xl" style={{ color: 'var(--mi-accent)' }}>✦</span>
              <span>Mi-Ispira</span>
            </div>
            <p className="text-sm leading-relaxed mb-5" style={{ color: '#9A9490' }}>
              Scopri il meglio vicino a te. Una directory editoriale che unisce attività locali, professionisti e realtà del territorio.
            </p>
            {/* Social */}
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border flex items-center justify-center transition-all hover:border-[var(--mi-accent)] hover:text-[var(--mi-accent)]"
                style={{ borderColor: '#3A3A3C', color: '#9A9490' }}
              >
                <Share2 size={15} />
              </a>
              <a
                href="https://mi-ispira.it"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full border flex items-center justify-center transition-all hover:border-[var(--mi-accent)] hover:text-[var(--mi-accent)]"
                style={{ borderColor: '#3A3A3C', color: '#9A9490' }}
              >
                <Globe size={15} />
              </a>
            </div>
          </div>

          {/* Esplora */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-widest mb-4 font-semibold" style={{ color: 'var(--mi-accent)' }}>
              Esplora
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Tutte le attività', href: '/attivita' },
                { label: 'Scopri', href: '/scopri' },
                { label: 'Categorie', href: '/attivita' },
                { label: 'Argomenti', href: '/attivita' },
                { label: 'Preferiti', href: '/preferiti' },
              ].map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.href}
                    className="text-sm transition-all hover:text-[var(--mi-accent)] accent-underline"
                    style={{ color: '#9A9490' }}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-widest mb-4 font-semibold" style={{ color: 'var(--mi-accent)' }}>
              Info
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Chi siamo', href: '/' },
                { label: 'Inserisci la tua attività', href: 'mailto:info@mi-ispira.it' },
                { label: 'Contattaci', href: 'mailto:info@mi-ispira.it' },
              ].map((l) => (
                <li key={l.label}>
                  {l.href.startsWith('mailto') ? (
                    <a
                      href={l.href}
                      className="text-sm transition-all hover:text-[var(--mi-accent)]"
                      style={{ color: '#9A9490' }}
                    >
                      {l.label}
                    </a>
                  ) : (
                    <Link
                      to={l.href}
                      className="text-sm transition-all hover:text-[var(--mi-accent)]"
                      style={{ color: '#9A9490' }}
                    >
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-widest mb-4 font-semibold" style={{ color: 'var(--mi-accent)' }}>
              Resta aggiornato
            </h4>
            <p className="text-sm mb-4 leading-relaxed" style={{ color: '#9A9490' }}>
              Ricevi le nuove attività e le selezioni editoriali direttamente nella tua inbox.
            </p>
            {subscribed ? (
              <div
                className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm"
                style={{ backgroundColor: 'rgba(31,122,90,0.15)', color: '#4ade80' }}
              >
                ✓ Iscrizione completata!
              </div>
            ) : (
              <form onSubmit={handleNewsletter} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="La tua email"
                  required
                  className="flex-1 h-10 px-3 rounded-xl border text-sm"
                  style={{
                    backgroundColor: '#1A1A1C',
                    borderColor: '#3A3A3C',
                    color: '#FAFAF8',
                    outline: 'none',
                  }}
                />
                <button
                  type="submit"
                  className="btn-gold w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                >
                  <ArrowRight size={16} />
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Decorative separator */}
        <div className="w-full h-px mb-8" style={{ backgroundColor: '#2A2A2C' }} />

        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: '#4A4A4E' }}>
            © {currentYear} Mi-Ispira. Tutti i diritti riservati.
          </p>
          <p className="text-xs italic font-display" style={{ color: 'var(--mi-accent)' }}>
            Scopri il meglio vicino a te.
          </p>
        </div>
      </div>
    </footer>
  );
}
